import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {IEquipment, Equipment} from 'app/blocks/model/equipment.model';
import {EquipmentService} from 'app/blocks/service/api/equiment.service';

@Injectable({
    providedIn: 'root'
})
export class EquipmentResource extends AbstractEntityResource<IEquipment> {
    constructor(equipmentService: EquipmentService, router: Router) {
        super(
            Resource.EQUIPMENTS,
            equipmentService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.EQUIPMENTS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.EQUIPMENTS),
            (entity?) => new Equipment(entity),
            (entity) => entity.code,
            'construction'
        );
    }
}
